import * as React from 'react';
import { Box } from '@mui/material';
import { SingleNumberCard } from '../numberInput/numberCards/singleNumberCard';

export const CardWithInput = ({
  label1,
  label2,
  icon,
  range,
  value,
  setValue
}: {
  label1: string;
  label2: string;
  icon: any;
  range: { min: number; max: number };
  value: number;
  setValue: (val: number) => void;
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        backgroundColor: '#fff',
        borderRadius: '0.9375rem',
        padding: '0.3125rem'
      }}
    >
      {/* code for circle with 45px width and height with bg color as yellow */}
      <Box
        sx={{
          width: '45px',
          height: '45px',
          backgroundColor: '#fff',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: '0.3125rem solid #f2f2f2',
          position: 'relative',
          top: '-1.875rem'
        }}
      >
        <img src={icon} alt="scale" />
      </Box>

      <Box
        sx={{
          border: '0.0625rem solid #D9D9D6',
          borderRadius: '0.9375rem',
          width: '90%',
          textAlign: 'center',
          marginBottom: '0.625rem'
        }}
      >
        <SingleNumberCard
          width={'100%'}
          title={label1.toUpperCase()}
          marginVal={'0.625rem'}
          range={range}
          subHead={label2}
          value={value}
          plusSymbolRequired={true}
          setValue={setValue}
        />
      </Box>
    </Box>
  );
};

export default CardWithInput;
